import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { getSettings, updateSettings } from '../../redux/actions/settings';
import {
  RouteWrapper,
  SettingsForm,
  Section,
  Content,
  HeadingSection,
  IconButton,
} from '../../components';

interface Props {
  dispatch: Function;
  settings: any;
  error: string | boolean;
}

interface State {
  isRequesting: boolean;
}

class Route extends React.Component<Props, State> {
  state = {
    isRequesting: true,
  };

  async componentDidMount() {
    const response = await this.props.dispatch(getSettings());
    this.setState({ isRequesting: false });
  }

  render() {
    return (
      <RouteWrapper
        title="Settings"
        requireAuth
        requirePermission="MANAGE_SETTINGS"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/settings', text: 'Global Settings' },
        ]}
      >
        <HeadingSection
          title="Global Settings"
          controls={[
            <IconButton
              key="back-button"
              icon="undo"
              className="is-default"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <Content>
            <SettingsForm
              handleSubmit={async (data) => {
                this.setState({ isRequesting: true });
                await this.props.dispatch(updateSettings(data));
                this.setState({ isRequesting: false });
              }}
              isRequesting={false}
              settings={this.state.isRequesting ? null : this.props.settings}
              error={this.props.error}
            />
          </Content>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ settings: { settings, error } }) => ({
  error,
  settings,
});

export default connect(mapStateToProps)(Route);
